import React from 'react';
import './App.scss';
import { Outlet } from 'react-router-dom';
import { Navigation } from './components/Navigation';
import { Footer } from './components/Footer';

interface AppProps {
  hideNavigation: boolean;
}

export const App: React.FC<AppProps> = ({ hideNavigation }) => {
  return (
    <>
      {!hideNavigation && <Navigation />}
      <div className="section">
        <Outlet />
      </div>
      {!hideNavigation && <Footer />}
    </>
  );
};
